import { validateValues as a } from "./index355.mjs";
function f(e, o, s) {
  if (typeof e != "string")
    return { hasError: !1, error: null };
  const t = a(o, s), r = Object.keys(t.errors).find((l) => e.split(".").every((n, i) => n === l.split(".")[i]));
  return { hasError: !!r, error: r ? t.errors[r] : null };
}
export {
  f as validateFieldValue
};
